export default __webpack_public_path__ + "static/media/icon-arrow-right-dark.09cb31a2.svg";